import React from 'react';
import './styles/Main.scss';
import Header from './Header/Header';
import HeroSection from './HeroSection/HeroSection';
import WhatAreLumiAds from './WhatAreLumiAds/WhatAreLumiAds';
import WhyLumiAds from './WhyLumiAds/WhyLumiAds';
import TryCreative from './TryCreative/TryCreative';
import Footer from './Footer/Footer';

const AdsPage = () => {
    return (
        <div className="ads_page">
            <Header />
            <HeroSection />
            <WhatAreLumiAds />
            <WhyLumiAds />
            <TryCreative />
            <Footer />
        </div>
    );
};

export default AdsPage;
